import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconBold = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	width: 24,
	height: 24,
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M10.071 16.412c0 2.443 0 4.83-0.054 7.16l-2.017 0.227v1.534h7.664c6.669 0 8.336-2.87 8.336-5.228 0-2.557-1.613-4.262-5.62-4.773 3.523-0.682 4.571-2.33 4.571-4.262 0-2.5-1.694-4.404-6.265-4.404h-8.686v1.534l2.017 0.227c0.054 2.387 0.054 4.802 0.054 7.16v0.824zM15.422 16.327c2.662 0 3.953 1.136 3.953 3.722 0 2.415-1.452 3.637-3.953 3.637h-0.861c-0.054-2.33-0.054-4.688-0.054-7.359h0.914zM15.503 8.315c2.097 0 3.092 0.994 3.092 3.097 0 2.245-1.049 3.409-3.334 3.409h-0.753c0-2.188 0-4.375 0.054-6.506h0.941z"
	})
});
export { SvgIconBold as ReactComponent };
